import Vue from "vue";
import Router from "vue-router";
import Main from "./views/layout/main.vue";
import store from "./store/store";
import tabRecursion from "@/comon/plugins/tabRecursion";
Vue.use(Router);

const router = new Router({
  mode: "history",
  // 跳转路由，重新设置屏幕滚动
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [{
      path: "/",
      redirect: "/home"
    },
    {
      path: "/main",
      component: Main,
      name: "main",
      children: [{
          path: "/home",
          name: "home",
          component: () => import("./views/pages/home.vue"),
          meta: {
            title: "首页",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/roleAdmin",
          name: "roleAdmin",
          component: () =>
            import("./views/pages/admin/roleAdmin.vue"),
          meta: {
            title: "角色权限",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/menuAdmin",
          name: "menuAdmin",
          component: () => import("./views/pages/admin/menuAdmin.vue"),
          meta: {
            title: "菜单管理",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/setPersonnel",
          name: "setPersonnel",
          component: () =>
            import("./views/pages/admin/setPersonnel.vue"),
          meta: {
            title: "人事设置",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/roleBind",
          name: "roleBind",
          component: () => import("./views/pages/admin/roleBind.vue"),
          meta: {
            title: "角色绑定",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/staffRecord",
          name: "staffRecord",
          component: () =>
            import("./views/pages/staffAdmin/staffRecord.vue"),
          meta: {
            title: "在职员工",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/departureList",
          name: "departureList",
          component: () =>
            import("./views/pages/staffAdmin/departureList.vue"),
          meta: {
            title: "离职员工",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/unFormal",
          name: "unFormal",
          component: () =>
            import("./views/pages/staffAdmin/unFormal.vue"),
          meta: {
            title: "待转正员工",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/organization",
          name: "organization",
          component: () =>
            import("./views/pages/staffAdmin/organization.vue"),
          meta: {
            title: "组织架构",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/attendanceAdmin",
          name: "attendanceAdmin",
          component: () =>
            import("./views/pages/staffAdmin/attendanceAdmin.vue"),
          meta: {
            title: "考勤管理",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/statistics",
          name: "statistics",
          component: () =>
            import("./views/pages/staffAdmin/statistics.vue"),
          meta: {
            title: "人事统计",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/onlineMeeting",
          name: "onlineMeeting",
          component: () =>
            import("./views/pages/unbuild.vue"),
          meta: {
            title: "在线会议",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/workOrder",
          name: "workOrder",
          component: () =>
            import("./views/pages/cooperativeOffice/workOrder.vue"),
          meta: {
            title: "工单管理",
            author: true,
            keepAlive: true
          }
        },
        // cooperativeOffice
        {
          path: "/projectManagement",
          name: "projectManagement",
          component: () =>
            import("./views/pages/cooperativeOffice/projectManagement.vue"),
          meta: {
            title: "项目管理",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/jobManagement",
          name: "jobManagement",
          component: () =>
            import("./views/pages/cooperativeOffice/jobManagement.vue"),
          meta: {
            title: "任务管理",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/meetingRecord",
          name: "meetingRecord",
          component: () =>
            import("./views/pages/cooperativeOffice/meetingRecord.vue"),
          meta: {
            title: "会议记录",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/meetingRoomSetup",
          name: "meetingRoomSetup",
          component: () =>
            import("./views/pages/cooperativeOffice/meetingRoomSetup.vue"),
            // import("./views/pages/unbuild.vue"),
          meta: {
            title: "会议室预定",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/activityPlan",
          name: "activityPlan",
          component: () =>
            import("./views/pages/unbuild.vue"),
          meta: {
            title: "活动计划",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/activityList",
          name: "activityList",
          component: () =>
            import("./views/pages/activityAdmin/activityList.vue"),
          meta: {
            title: "活动列表",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/recruitPlan",
          name: "recruitPlan",
          component: () =>
            import("./views/pages/unbuild.vue"),
          meta: {
            title: "招聘计划",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/recruitList",
          name: "recruitList",
          component: () =>
            import("./views/pages/recruitAdmin/recruitList.vue"),
          meta: {
            title: "招聘列表",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/interviewList",
          name: "interviewList",
          component: () =>
            import("./views/pages/recruitAdmin/interviewList.vue"),
          meta: {
            title: "面试列表",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/recruitmentTest",
          name: "recruitmentTest",
          component: () =>
            import("./views/pages/unbuild.vue"),
          meta: {
            title: "招聘测试",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/classifyAdmin",
          name: "classifyAdmin",
          component: () =>
            import("./views/pages/unbuild.vue"),
          meta: {
            title: "资产分类",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/thingsAdmin",
          name: "thingsAdmin",
          component: () =>
            import("./views/pages/thingsAdmin/thingsAdmin.vue"),
            // import("./views/pages/unbuild.vue"),
          meta: {
            title: "资产列表",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/supplierAdmin",
          name: "supplierAdmin",
          component: () =>
            import("./views/pages/unbuild.vue"),
          meta: {
            title: "供应商管理",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/trainPlan",
          name: "trainPlan",
          component: () =>
            import("./views/pages/unbuild.vue"),
          meta: {
            title: "培训计划",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/trainList",
          name: "trainList",
          component: () =>
            import("./views/pages/unbuild.vue"),
          meta: {
            title: "培训列表",
            author: true,
            keepAlive: true
          }
        },
        {
          path: "/versions",
          name: "versions",
          component: () =>
            import("./views/pages/admin/versions.vue"),
          meta: {
            title: "版本发布",
            author: true,
            keepAlive: true
          }
        },
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/pages/login/login.vue"),
      meta: {
        title: "login",
        author: false
      }
    },
    {
      path: "*",
      name: "404",
      component: () => import("./views/pages/404.vue"),
      meta: {
        title: "404",
        author: false
      }
    }
  ]
});

// 登录验证
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (to.meta.author) {
    if (token) {
      let menu_id = tabRecursion(
        "/" + to.name,
        JSON.parse(localStorage.getItem("menu_list"))
      );
      localStorage.setItem("menu_id", menu_id);
      store.commit("MENU_ID", menu_id);
      store.dispatch("getMenuAuth");
      next();
    } else {
      // if (to.path == "/login") {
      //   next();
      // } else {
      //   next("./login");
      // }
      location.href = `${process.env.VUE_APP_AUTH_URL}/user/login?redirect=${encodeURIComponent(location.href)}`;
    }
  } else {
    next();
  }
});

export default router;